import { useEffect, useRef } from 'react';
import { useOfflineStore } from '../../../store/useOfflineStore';

export function useAutoRefresh() {
  const { boardSettings, snapshotBoard } = useOfflineStore();
  const intervalsRef = useRef<Record<string, ReturnType<typeof setInterval>>>({});

  useEffect(() => {
    const existing = intervalsRef.current;

    // Clear intervals for boards that no longer need them
    for (const boardId of Object.keys(existing)) {
      const s = boardSettings[boardId];
      if (!s || !s.enabled || s.mode !== 'always-ready') {
        clearInterval(existing[boardId]);
        delete existing[boardId];
      }
    }

    // Set up intervals for always-ready boards
    for (const [boardId, s] of Object.entries(boardSettings)) {
      if (!s.enabled || s.mode !== 'always-ready') continue;
      if (existing[boardId]) continue; // already running

      const ms = (s.refreshIntervalMinutes ?? 15) * 60 * 1000;
      existing[boardId] = setInterval(() => {
        if (!navigator.onLine) return; // skip if offline
        void snapshotBoard(boardId).catch(() => {});
      }, ms);
    }

    return () => {
      for (const id of Object.values(existing)) clearInterval(id);
      intervalsRef.current = {};
    };
  }, [boardSettings, snapshotBoard]);
}
